import React from "react";

export const Card = ({ children, style, onClick, className = "" }) => (
  <div
    onClick={onClick}
    style={style}
    className={`bg-s rounded-[14px] p-4 border border-b0 shadow-[0_1px_3px_rgba(0,0,0,0.04)] ${className}`}
  >
    {children}
  </div>
);
